import React from "react";
import { useParams } from "react-router-dom";
import { APIError } from "../../components/APIError";
import { useAccountWarnings } from "./hooks/useAccountWarnings";
import { AlertBlock } from "../../components/AlertBlock";
import { BoxProps } from "@material-ui/core";

/**
 * Displays the account warnings returned from the account/warnings API
 */
export const AccountWarnings: React.FC<Partial<BoxProps>> = (props) => {
  const { accountNumber } = useParams();
  const { status, data: warnings, error } = useAccountWarnings(accountNumber!);

  return (
    <>
      {error ? (
        <APIError
          title="We could not load the warnings for this account."
          messages={[(error as Error).message]}
          {...props}
        />
      ) : status === "loading" ? null : (
        warnings && (
          <AlertBlock
            list={warnings.length > 1}
            variant="warning"
            messages={warnings!.map((warning) => warning.message)}
            isClosable={false}
            {...props}
          />
        )
      )}
    </>
  );
};
